export const opcoesUf = [
  ["AC", "Acre"], ["AL", "Alagoas"], ["AP", "Amapá"], ["AM", "Amazonas"],
  ["BA", "Bahia"], ["CE", "Ceará"], ["DF", "Distrito Federal"],
  ["ES", "Espírito Santo"], ["GO", "Goiás"], ["MA", "Maranhão"],
  ["MT", "Mato Grosso"], ["MS", "Mato Grosso do Sul"], ["MG", "Minas Gerais"],
  ["PA", "Pará"], ["PB", "Paraíba"], ["PR", "Paraná"], ["PE", "Pernambuco"],
  ["PI", "Piauí"], ["RJ", "Rio de Janeiro"], ["RN", "Rio Grande do Norte"],
  ["RS", "Rio Grande do Sul"], ["RO", "Rondônia"], ["RR", "Roraima"],
  ["SC", "Santa Catarina"], ["SP", "São Paulo"], ["SE", "Sergipe"],
  ["TO", "Tocantins"],
];

export const opcoesCorRaca = ["Branca", "Preta", "Parda", "Amarela", "Indígena"];
export const opcoesSexo = ["Masculino", "Feminino", "Outro", "Prefiro não dizer"];
export const opcoesEstadoCivil = [
  "Solteiro(a)", "Casado(a)", "União estável", "Separado(a)", "Divorciado(a)", "Viúvo(a)",
];
export const opcoesEscolaridade = [
  "Não alfabetizado",
  "Ensino fundamental incompleto",
  "Ensino fundamental cursando",
  "Ensino fundamental completo",
  "Ensino médio incompleto",
  "Ensino médio cursando",
  "Ensino médio completo",
  "Ensino superior incompleto",
  "Ensino superior cursando",
  "Ensino superior completo",
  "Pós-graduação",
];

export const novoEnvolvido = () => ({
  id: "",
  tipo: "Autor",
  nome: "",
  nomeSocial: "",
  alcunha: "",
  cpf: "",
  cnhPpd: "",
  conduzido: false,
  corRaca: "",
  sexo: "",
  nascimento: "",
  orientacaoSexual: "",
  naturalidade: "",
  profissao: "",
  estadoCivil: "",
  escolaridade: "",
  endereco: "",
  numero: "",
  complemento: "",
  bairro: "",
  municipio: "",
  uf: "",
  pontoReferencia: "",
  telefone: "",
  nomeMae: "",
  nomePai: "",
  obs: "",
});

export const normalizarEnvolvido = (envolvido = {}) => {
  const sexoNormalizado = typeof envolvido.sexo === "string"
    ? envolvido.sexo.toLowerCase() === "masculino" ? "Masculino"
      : envolvido.sexo.toLowerCase() === "feminino" ? "Feminino" : envolvido.sexo
    : "";
  return {
    ...novoEnvolvido(),
    ...envolvido,
    sexo: sexoNormalizado,
    nascimento: envolvido.nascimento && dataParaInput(envolvido.nascimento)
      ? envolvido.nascimento
      : "",
  };
};

export const dataParaInput = (value = "") => {
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  return match ? `${match[3]}-${match[2]}-${match[1]}` : "";
};

export const dataParaPersistencia = (value = "") => {
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : value;
};

export const formatarTelefone = (value = "") => {
  const digits = value.replace(/\D/g, "");
  if (value.trim().startsWith("+") || digits.length > 11) return value;
  if (digits.length <= 2) return digits;
  const ddd = digits.slice(0, 2);
  const local = digits.slice(2);
  const separador = digits.length === 11 ? 5 : 4;
  const numero = local.length > separador
    ? `${local.slice(0, separador)}-${local.slice(separador)}`
    : local;
  return `(${ddd}) ${numero}`;
};

export const isValidCpf = (value) => {
  if (!/^(?:\d{11}|\d{3}\.\d{3}\.\d{3}-\d{2})$/.test(String(value || '').trim())) return false;
  const digitsOnly = String(value || "").replace(/\D/g, "");
  if (!/^\d{11}$/.test(digitsOnly) || /^(\d)\1+$/.test(digitsOnly)) return false;
  const digits = digitsOnly.split("").map(Number);
  for (let position = 9; position < 11; position += 1) {
    const sum = digits.slice(0, position)
      .reduce((total, digit, index) => total + digit * (position + 1 - index), 0);
    const remainder = (sum * 10) % 11;
    if (digits[position] !== (remainder === 10 ? 0 : remainder)) return false;
  }
  return true;
};

export const isValidBirthDate = (value) => {
  if (!value) return true;
  const normalized = dataParaInput(value);
  if (!normalized) return false;
  const [year, month, day] = normalized.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day &&
    date <= today;
};

export const validarEnvolvido = (envolvido) => {
  if (!envolvido.nome?.trim()) {
    return { campo: "nome", mensagem: "Informe o nome completo." };
  }
  if (envolvido.cpf && !isValidCpf(envolvido.cpf)) {
    return { campo: "cpf", mensagem: "Informe um CPF válido ou deixe o campo em branco." };
  }
  if (envolvido.nascimento && !isValidBirthDate(envolvido.nascimento)) {
    return { campo: "nascimento", mensagem: "Informe uma data válida, não futura." };
  }
  if (envolvido.telefone) {
    const telefone = envolvido.telefone.trim();
    const digitos = telefone.replace(/\D/g, "");
    if (!/^[+0-9\s().-]+$/.test(telefone) || digitos.length < 7 || digitos.length > 15) {
      return { campo: "telefone", mensagem: "Informe um telefone válido, incluindo DDD quando houver." };
    }
  }
  return null;
};
